export const merchItems = [
  {
    id: "1",
    name: "The Art of Shantae SDCC Edition",
    thumbnail: "images/the_art_of_shantae_1.png",
  },
  {
    id: "2",
    name: "The Art of Shantae",
    thumbnail: "images/the_art_of_shantae_2.png",
  },
  {
    id: "3",
    name: "Tropical Trickster T-Shirt",
    thumbnail: "images/tropical_shirt.png",
  },
  {
    id: "4",
    name: "Tropical Blacklight T-Shirt",
    thumbnail: "images/tropical_blacklight.png",
  },
  {
    id: "5",
    name: "Charagumin Shantae Figurine",
    thumbnail: "images/charagumin_shantae.png",
  },
  {
    id: "6",
    name: "Charagumin Risky Boots Figurine",
    thumbnail: "images/charagumin_riskyboots.png",
  },
  {
    id: "7",
    name: "Charagumin Rottytops Figurine",
    thumbnail: "images/charagumin_rottytops.png",
  },
  {
    id: "8",
    name: "Charagumin Sky Figurine",
    thumbnail: "images/charagumin_sky.png",
  },
  {
    id: "9",
    name: "Shantae Nendoroid Figurine",
    thumbnail: "images/nendoroid_shantae.png",
  },
  {
    id: "10",
    name: "LRG Classic Shantae Pogs",
    thumbnail: "images/classic_shantae_pog.png",
  },
  {
    id: "11",
    name: "Shantae Risky's Revenge Vinyl",
    thumbnail: "images/risky_s-revenge_vinyl.png",
  },
  {
    id: "12",
    name: "Shantae 2022 Vinyl Red",
    thumbnail: "images/product_shantae_vinyl_2022_front.png",
  },
  {
    id: "13",
    name: "Shantae Plush",
    thumbnail: "images/shantae_plush.png",
  },
  {
    id: "14",
    name: "Rottytops Plush",
    thumbnail: "images/rottytops_plush.png",
  },
  {
    id: "15",
    name: "Shantae GBC (Limited Run Games)",
    thumbnail: "images/shantae_gbc_lrg.png",
  },
  {
    id: "16",
    name: "Shantae GBC (Capcom)",
    thumbnail: "images/shantae_gbc_real.png",
  },
];
